import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { BatchTypeEnum } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  startDate?: string;
  endDate?: string;
  year?: string;
  groupByShippingMarks?: boolean;
  batchType: BatchTypeEnum;
}

export const useGenerateCustomsRegister = () => {
  return useMutation({
    mutationFn: async ({ startDate, endDate, year, batchType, groupByShippingMarks }: HookProps) => {
      await request(
        {
          path: `batches/generate-customs-register`,
          method: 'POST',
          authenticate: true,
          dataObject: { startDate, endDate, year, batchType, groupByShippingMarks },
        },
        true,
      );
    },
    onSuccess: () => {
      toast.success('The customs register is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the customs register!');
    },
  });
};
